import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/pages/Homepage'
import ContestListPage from '@/pages/ContestListPage'
import NominationPage from '@/pages/NominationPage'
import NominationSinglePage from '@/pages/NominationSinglePage'
// const NominationSinglePage = () => import('@/pages/NominationSinglePage');
import VoteCardDemoPage from '@/pages/VoteCardDemoPage'
import VoteLandingPage from '@/pages/VoteLandingPage'
import VotingExperiencePage from '@/pages/VotingExperiencePage'
import VotingExperienceSinglePage from '@/pages/VotingExperienceSinglePage'
import PageNotFound from '@/pages/PageNotFound'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

let base = '/';
if(process.env.NODE_ENV === 'production') {
  base = '/best_of_dayton/';
}

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  base: base,
  // base: '/best_of_dayton/',
  // base: '/',
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage
    },
    /*{
      path: '/nominate',
      name: 'nominations',
      component: NominationPage
    },*/
    {
      path: '/nominate/',
      name: 'nominations',
      component: NominationPage
    },
    /*{
      path: '/nominate/:id',
      name: 'nominationsingle',
      component: NominationSinglePage
    },*/
    {
      path: '/nominate/:id/',
      name: 'nominationsingle',
      component: NominationSinglePage
    },
    /*{
      path: '/vote',
      name: 'vote',
      component: VoteLandingPage
    },*/
    {
      path: '/vote/',
      name: 'vote',
      component: VoteLandingPage
    },
    {
      path: '/votenow',
      name: 'votenow',
      component: VotingExperiencePage
    },
    {
      path: '/votenow/',
      name: 'votenow',
      component: VotingExperiencePage
    },
    {
      path: '/votenow/:id',
      name: 'votenowsingle',
      component: VotingExperienceSinglePage
    },
    {
      path: '/votenow/:id/',
      name: 'votenowsingle',
      component: VotingExperienceSinglePage
    },
    /*{
      path: '/oldvotedemo',
      name: 'oldvotedemo',
      component: VoteCardDemoPage
    },*/
    {
      path: '*',
      name: 'not_found',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js